// Services.js

import React from "react";

import {
  Smartphone,
  Wallet,
  Receipt,
  Ship,
  Globe2,
  ShieldCheck,
  TrendingUp,
  BriefcaseBusiness,
  ArrowRight,
} from "lucide-react";

import "../Styles/services.css";

import { Link } from "react-router-dom";

const services = [
  {
    title: "Mobile Top-Up",
    description:
      "Top-up services for Digicel, GTT and Enet — retail and wholesale.",
    icon: Smartphone,
    path: "/services/topup",
  },

  {
    title: "MMG+ Transactions",
    description:
      "Fast, secure MMG+ transactions powered by Wakenaam’s only MMG+ Superagent.",
    icon: Wallet,
    path: "/services/mmg",
  },

  {
    title: "Bill Payments",
    description:
      "Conveniently pay your utility and financial bills under one roof.",
    icon: Receipt,
    path: "/services/bills",
  },

  {
    title: "Ferry Pass Booking",
    description:
      "Book passenger and vehicle ferry passes anywhere across Guyana.",
    icon: Ship,
    path: "/services/ferry",
  },

  {
    title: "Money Transfers",
    description:
      "MoneyGram and WIDIT services for local and international transfers.",
    icon: Globe2,
    path: "/services/business",
  },

  {
    title: "Insurance Brokerage",
    description:
      "New insurance policies, renewals and professional brokerage services.",
    icon: ShieldCheck,
    path: "/services/insurance",
  },

{
  title: "Loans",
  description:
    "Explore Financing Opportunities with RCS Ready Finance.",
  icon: TrendingUp,
  path: "/new",
},

  {
    title: "Other Services",
    description:
      "Additional financial and business services tailored to your needs.",
    icon: BriefcaseBusiness,
    path: "/services/others",
  },
];

const Services = () => {

  return (
    <div className="modern-services-page">

      {/* HERO */}
      <section className="modern-services-hero">

        <div className="modern-services-overlay" />

        <div className="modern-services-content">

          <div className="modern-services-badge">
            OUR SERVICES
          </div>

          <h1 className="modern-services-heading">
            Financial Services
            <span> Built Around You.</span>
          </h1>

          <p className="modern-services-text">
            Discover RCS’s complete range of modern
            financial, payment and business services
            designed for customers, agents, partners
            and investors across Guyana.
          </p>

        </div>

      </section>

      {/* SERVICES GRID */}
      <section className="modern-services-grid">

        {services.map((service, index) => {

          const Icon =
            service.icon;

          return (
            <Link
              to={service.path}
              className="modern-service-card"
              key={index}
            >

              <div className="modern-service-icon">
                <Icon size={34} />
              </div>

              <div className="modern-service-body">

                <h3>
                  {service.title}
                </h3>

                <p>
                  {service.description}
                </p>

              </div>

              <div className="modern-service-arrow">
                <ArrowRight size={22} />
              </div>

            </Link>
          );
        })}

      </section>

    </div>
  );
};

export default Services;